import React, { FC } from 'react';

import { LoadingSpinner } from '@abyss/web/ui/LoadingSpinner';
import { ResultsProps } from '../types';

export const ResultsSearching: FC<ResultsProps> = ({ id }) => {
  const testId = `${id}ResultsSearching`;

  return (
    <div className="resultsSearching" data-testid={testId} data-cy={testId}>
      <LoadingSpinner
        size="$lg"
        ariaLoadingLabel="Event Search, Searching data, Waiting for data"
        isLoading
      />
      <div className="labelResultsSearching" data-cy="labelResultsSearching">
        Please wait
      </div>
    </div>
  );
};
